
import { Component, Vue } from 'vue-property-decorator'
import SoilDialog from './soilDialog.vue'

@Component({
  name: 'SoilList',
  components: {
    SoilDialog
  }
})
export default class extends Vue {
    private searchInfo = {
      deviceNumber: '',
      deviceName: '',
      deviceStatus: ''
    }

    private page = 1
    private size = 10
    private total = 0
    private tableData =[]
    private loading = false
    private showDialog = false
    private detail = {}

    created () {
      this.getData()
    }

    // 查询
    searchData () {
      this.page = 1
      this.getData()
    }

    // 获取表格数据
    getData () {
      this.loading = true
      this.$axios.get(this.$apis.smartHouse.selectSqSoilInfoByPage, {
        ...this.searchInfo,
        page: this.page,
        size: this.size
      }).then((res) => {
        this.total = res.soil.total || 0
        this.tableData = res.soil.list || []
      }).finally(() => {
        this.loading = false
      })
    }

    // 新增
    onSetting (row: any) {
      this.showDialog = true
      if (row) {
        this.detail = JSON.parse(JSON.stringify(row))
      }
    }

    onHistory (deviceNumber: string) {
      this.$router.push({
        params: { deviceNumber: deviceNumber },
        name: 'smartHouseDeviceSoilHistory'
      })
    }
}
